export const coHandlerErrorMessage =
  "You cannot timestamp 'UL: Submit to Authority/Authority Review' for <b>'@orderNumber'</b>. Only the assigned CO Handler can complete it."

export const coHandlerErrorHeader = 'Unauthorized Action'
